<form [formGroup]="formGroup" (action)="formAction()">
	@for(formField of formFields; track $index) { @switch (formField.type) { @case ('INPUT-TEXT') {
	<mat-form-field class="pb-2 w-100">
		<mat-label>{{ formField.label.translate ? (formField.label.value | translate) : formField.label.value }}</mat-label>
		<input matInput type="text" [formControlName]="formField.name" />
	</mat-form-field>
	} @case ('INPUT-TEXT-LANG') { @for(langCode of avaliableLanguagesCodes; track $index) {
	<mat-form-field class="pb-2 w-100">
		<mat-label>{{ formField.label.translate ? (formField.label.value | translate) : formField.label.value }}</mat-label>
		<input matInput type="text" [formControlName]="formField.name + (langCode | titlecase)" />
		<button class="me-1" mat-icon-button matSuffix type="button" disabled>
			<img [src]="externalAssets + '/flags/' + langCode + '.svg'" />
		</button>
	</mat-form-field>
	} } } }
</form>
